export const phoneNumberRegex =
  /(\+?55(\s){0,})?(\(?0?\d\d\)?(\s){0,})([9]?(\s){0,}[0-9]{4}[\s.-]{0,}[0-9]{4})(\r?\n|\r)?/;
